import init from '@arkas/core';
import { reducer as oidcReducer } from 'redux-oidc';

const requestTimeout = process.env.ARKAS_APP_REQUEST_TIMEOUT;

const store = init({
  appConfig: {
    baseServiceUrl: process.env.ARKAS_APP_API_URL,
    request: {
      requestTimeout: requestTimeout ? Number(requestTimeout) : 100000000
    },
    signalr: {
      url: process.env.ARKAS_APP_API_URL as string
    }
  },
  stateConfig: {
    redux: {
      reducers: {
        oidc: oidcReducer
      }
    },
    loadingConfig: {
      blacklist: [
        'mutabakatModel/mutabakatBaslat',
        'mutabakatModel/ekstreAktarimiBaslat',
        'mutabakatModel/acikKalemAktarimiBaslat',
        'mutabakatModel/topluOnayaGonder',
        'mutabakatModel/cokluOnayaGonder',
        'mutabakatModel/cokluGeriCek',
        'mutabakatModel/cokluSil'
      ]
    }
  }
});

export default store;
